/*eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
/*eslint-disable no-unused-vars */
import PropTypes from 'prop-types';
// import Select from 'react-select';

import {
  FormControl,
  FormControlLabel,
  Checkbox,
  MenuItem,
  OutlinedInput,
  Radio,
  RadioGroup,
  Select,
  Typography
} from '@material-ui/core';

import uuidv4 from 'uuid/v4';
import { i18n } from '../App.js';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  buttons: {
    ...theme.buttons
  },
  label: {
    marginTop: 24,
    marginBottom: 8,
    fontSize: 18
  },
  prefix: {
    fontWeight: 'bold',
    paddingRight: '4px',
    color: '#e53e51'
  }
}));

/* eslint-disable react/display-name */

const Question = React.memo(function Question({
  answerType,
  label,
  prefix,
  type,
  icon,
  suffix,
  suffixPlural,
  numbers,
  choices,
  display,
  previousAnswer,
  defaultValue,
  onChange
}) {
  // console.log('DRAW QUESTION');

  const classes = useStyles();

  const [answer, setAnswer] = useState(previousAnswer || {});

  useEffect(() => {
    if (answer.value) {
      // console.log('CHANGING ANSZER', answer);
      onChange(answerType, answer);
    }
  }, [answer, answerType, onChange]);

  let listOfChoices = [];
  let choiceLabel = '';

  if ((type === 'choice' || type === 'checkbox') && choices.length) {
    choices.forEach((choice, index) => {
      if (suffix) {
        choiceLabel =
          index === 0
            ? `${choice.title} ${suffix}`
            : `${choice.title} ${suffixPlural}`;
      } else {
        choiceLabel = choice.title;
      }
      listOfChoices.push({
        label: choiceLabel,
        value: choice.id,
        gain: {
          co2: choice.co2,
          euros: choice.euros,
          pounds: choice.pounds
        }
      });
    });
  } else if (type === 'number' && numbers[0]) {
    const nbrs = numbers[0];
    for (
      let i = parseInt(nbrs.minimum, 10);
      i <= parseInt(nbrs.maximum, 10);
      i += 1
    ) {
      if (suffix) {
        choiceLabel = i <= 1 ? `${i} ${suffix}` : `${i} ${suffixPlural}`;
      } else {
        choiceLabel = i;
      }
      listOfChoices.push({
        label: choiceLabel,
        value: i,
        gain: {
          co2: nbrs.co2 * (i + 1),
          euros: nbrs.euros * (i + 1),
          pounds: nbrs.pounds * (i + 1)
        }
      });
    }
  }

  const renderDropdown = () => {
    const superChargedListOfChoices = [
      { label: i18n._('Votre réponse'), value: 0 },
      ...listOfChoices
    ];
    const setSelection = e => {
      // Find option
      const answer = superChargedListOfChoices.find(
        opt => opt.value === e.target.value
      );
      setAnswer(answer);
    };
    if (!answer.value && !defaultValue) {
      answer.value = 0;
    } else if (!answer.value && defaultValue) {
      answer.value = defaultValue;
    }
    return (
      <FormControl required>
        <Select
          input={<OutlinedInput />}
          value={answer.value}
          onChange={setSelection}
          name={answerType}
          disabled={!!defaultValue}
        >
          {superChargedListOfChoices.map(opt => (
            <MenuItem key={`nbb_${opt.value}`} value={opt.value}>
              {opt.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  };

  const renderRadio = () => {
    return (
      <>
        {listOfChoices.map(obj => {
          const uuid = uuidv4();
          if (defaultValue && !answer.value) {
            answer.value = defaultValue;
          }
          return (
            <FormControl key={uuid}>
              <FormControlLabel
                onChange={() => {
                  setAnswer(obj);
                }}
                checked={obj.value === answer.value}
                disabled={!!defaultValue}
                value={obj.value}
                control={<Radio />}
                label={obj.label}
              />
            </FormControl>
          );
        })}
      </>
    );
  };

  const renderCheckbox = () =>
    listOfChoices.map(obj => {
      const uuid = uuidv4();
      if (defaultValue && !answer.value) {
        answer.value = defaultValue;
      }
      return (
        <FormControl key={uuid}>
          <FormControlLabel
            label={obj.label}
            name={`group_${answerType}`}
            value={obj.value}
            checked={obj.value === answer.value}
            disabled={!!defaultValue}
            onChange={() => setAnswer(obj)}
            control={<Checkbox />}
          />
        </FormControl>
      );
    });

  const renderNumber = () => (
    // Do not forget default value
    <input
      type="number"
      value={answer.value || previousAnswer.value || defaultValue}
      disabled={!!defaultValue}
      onChange={() => console.log('TODO render number')}
    />
  );

  const renderText = () => (
    // Do not forget default value
    <input
      type="text"
      value={answer.value || previousAnswer.value || defaultValue}
      multiline
      disabled={!!defaultValue}
      onChange={() => console.log('TODO render text')}
    />
  );

  let formElement;

  switch (display) {
  case 'dropdown':
    formElement = renderDropdown();
    break;
  case 'radio':
    formElement = renderRadio();
    break;
  case 'checkbox':
    formElement = renderCheckbox();
    break;
  case 'number':
    formElement = renderNumber();
    break;
  default:
    formElement = renderText();
    break;
  }
  return (
    <>
      <div className={classes.label}>
        <span className={classes.prefix}>{prefix}</span>
        {label}
      </div>
      <div className={`${answerType}Question`}>{formElement}</div>
    </>
  );
});

Question.propTypes = {
  answerType: PropTypes.string,
  type: PropTypes.string,
  label: PropTypes.string.isRequired,
  icon: PropTypes.string,
  suffix: PropTypes.string,
  suffixPlural: PropTypes.string,
  choices: PropTypes.arrayOf(PropTypes.shape),
  numbers: PropTypes.arrayOf(PropTypes.shape),
  display: PropTypes.string,
  prefix: PropTypes.string,
  horizontal: PropTypes.bool,
  onChange: PropTypes.func,
  previousAnswer: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape),
    PropTypes.shape(),
    PropTypes.string,
    PropTypes.number
  ]),
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.shape()
};

Question.defaultProps = {
  answerType: 'commitment',
  type: 'choice',
  choices: null,
  numbers: null,
  display: '',
  prefix: null,
  icon: null,
  suffix: '',
  suffixPlural: '',
  horizontal: true,
  style: null,
  previousAnswer: null,
  onChange: null
};

export default Question;
